export default __webpack_public_path__ + "static/media/elevator.d66cdf13.png";